/* unplugin-vue-components disabled */import script from "./case.vue?vue&type=script&setup=true&lang=ts"
export * from "./case.vue?vue&type=script&setup=true&lang=ts"

import "./case.vue?vue&type=style&index=0&id=61b7eade&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61b7eade"]])

export default __exports__